import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

export default function AnalyticsListener() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Defer ~50ms so React Helmet has updated document.title for this route.
    // 0ms isn't enough on initial mount — Helmet needs a render cycle to settle.
    const id = setTimeout(() => {
      trackPageView(pathname + search, document.title);
    }, 50);
    return () => clearTimeout(id);
  }, [pathname, search]);

  return null;
}
